/**
 * Datadog RUM public API — no SDK imports; safe from error boundaries and layouts.
 */

import { isDatadogRumEnabled } from "@/lib/datadog/config";

let bootstrapStarted = false;

export function initDatadogRum(): void {
  if (!isDatadogRumEnabled() || bootstrapStarted) return;
  bootstrapStarted = true;
  void import("@/lib/datadog/rum-internal").then((mod) => mod.initDatadogRum());
}

type RouterTransitionArgs = Parameters<
  Awaited<typeof import("@/lib/datadog/rum-internal")>["onRouterTransitionStart"]
>;

export function onRouterTransitionStart(...args: RouterTransitionArgs): void {
  if (!isDatadogRumEnabled()) return;
  void import("@/lib/datadog/rum-internal").then((mod) =>
    mod.onRouterTransitionStart(...args),
  );
}

export function reportNextjsError(error: Error): void {
  if (!isDatadogRumEnabled()) return;
  void import("@/lib/datadog/rum-internal").then((mod) =>
    mod.reportNextjsError(error),
  );
}
